<template>
  <PreviewSheet class="gallery-preview" radius="0">
    <div class="flex-col justify-center gap-10">
      <div class="gallery-preview__text flex-col gap-4">
        <PreviewTypography :text="headerContent" variant="heading2" />
        <PreviewTypography
          v-if="subtitle"
          :text="subtitle"
          variant="paragraphRegular"
        />
        <PreviewButton v-if="actionLabel" :title="actionLabel" caret />
      </div>

      <OwnGrid class="gallery-preview__img-grid">
        <PreviewSheet
          v-for="(item, idx) in imageSrcs"
          :key="idx"
          class="gallery-preview__img"
          :style="{ backgroundImage: `url(${item})` }"
        />
      </OwnGrid>
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import PreviewButton from '@/lib/builder/public/preview/PreviewButton.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'
import { OwnGrid } from '@/ui/OwnGrid'

import type { GallerySection } from '../../../WebsiteBuilder.types'

const props = defineProps<{
  content: GallerySection
}>()

const currentBlockParams = computed(() => {
  return props.content?.params
})

type GalleryMediaItem = NonNullable<GallerySection['params']['media']>[number]

const mediaItems = computed<GalleryMediaItem[]>(() => {
  return currentBlockParams.value?.media ?? []
})

const imageSrcs = computed(() => mediaItems.value.map((m) => m.params.src))

const headerContent = computed(() => currentBlockParams.value.title)

const subtitle = computed(() => currentBlockParams.value.description)
const actionLabel = computed(
  () => currentBlockParams.value?.action?.params?.label ?? null
)
</script>

<style lang="scss" scoped>
.gallery-preview {
  padding: 120px;

  &__text {
    max-width: 672px;
    padding: 0 16px;
    text-align: left;
  }

  &__img-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    flex: 1;
    width: 100%;
  }

  &__img {
    aspect-ratio: 1 / 1;
    background-size: cover;
  }
}
</style>
